// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/scss/fieldsettings.scss
// module id = 341
// module chunks = 2